export const educationData = [
    {
        id: 1,
        institution: 'Aligarh Muslim University (A.M.U)',
        course: 'MCA — Master of Computer Applications',
        startYear: '2013',
        endYear: '2016',
        score: '78.30%'
    },
    {
        id: 2,
        institution: 'Aligarh Muslim University (A.M.U)',
        course: 'B.Sc.',
        startYear: '2010',
        endYear: '2013',
        score: '70.60%'
    },
    {
        id: 3,
        institution: 'W.B.C.H.S.E',
        course: '12th',
        startYear: '2008',
        endYear: '2010',
        score: '76.67%'
    },
    {
        id: 4,
        institution: 'W.B.B.S.E',
        course: '10th',
        startYear: '2007',
        endYear: '2008',
        score: '78.50%'
    }
]